  <template>
  <va-card :title="title">
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input class="ma-0" :value="term" :placeholder="$t('tables.search')" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      no-pagination
      no-data-label="No events"
      hoverable
      v-if="!loading"
    >
      <template slot="gw_time" slot-scope="{rowData}">{{ formatGwTime(rowData) }}</template>
    </va-data-table>
  </va-card>
</template>

<script>
import { debounce } from 'lodash'
// import data from '../markup-tables/data.json'
import hiqapi from '@/hiqapi/hiqapi'
import { DateTime } from 'luxon'

export default {
  props: ['location'],
  data () {
    return {
      // siteData: [{ 'name': 'Loading...' }],
      loading: true,
      term: null,

      listData: [], // list of currentlistFrom
      currentListArgs: null, // last args used (to tell if we need to reload or if we already have what we need)
      // _.listType_  _.siteId_   _.gwSerial_    _selectedId_  _currentlistFrom_
      //     sites         -            -              -         sites
      //     sites         -            -             11         sites11
      //      gws         11            -              -         site11
      //      gws         11            -             22         gw22
      //     invs         11           22              -         gw22
      //     invs         11           22             33         inv33

    }
  },
  watch: {
    location: {
      immediate: true, // so this is called at startup (in addition to subsequent changes)
      deep: true,
      handler (val, oldVal) {
        if (!val.selectedId) {
          console.log('DET-LOCATION ignoring location change because selectedId not set')
          return
        }

        console.log(`DET-LOCATION will get events for site=${val.siteId} gw=${val.gwSerial} type=${val.listType} sel=${val.selectedId}`)
        let args = null

        // only inv events supported right now
        if (val.listType === val.TYPE_SITES) {
          // args = `site_id=${val.selectedId}`
          console.log('DET ERROR unexpected location update listType=', val.listType)
        } else if (val.listType === val.TYPE_GWS) {
          // args = `gw_serial=${val.selectedId}`
          console.log('DET ERROR unexpected location update listType=', val.listType)
        } else {
          args = `inv_serial=${val.selectedId}`
        }

        if (args === this.currentListArgs) {
          console.log('   DET already loaded')
          return
        }

        console.log('    DET currentListArgs=' + this.currentListArgs + ', args=' + args)

        // Get the list

        this.loading = true
        hiqapi.getcb('/faults?' + args, this.setData)

        this.currentListArgs = args
      },
    },
  },
  computed: {
    title () {
      return ''
    },
    fields () {
      return [
        { name: '__slot:gw_time', title: this.$t('tables.events.headings.gw_time') + ' (' + DateTime.local().toFormat('ZZZZ') + ')', dataClass: 'text-right-nowrap' },
        { name: 'gw_serial', title: this.$t('tables.events.headings.gw_serial'), dataClass: 'text-right-nowrap' },
        { name: 'inv_serial', title: this.$t('tables.events.headings.inv_serial'), dataClass: 'text-right-nowrap' },
        { name: 'module_name', title: this.$t('tables.events.headings.module_name'), dataClass: 'text-center' },
        { name: 'fault_code', title: this.$t('tables.events.headings.fault_code'), dataClass: 'text-center' },
        { name: 'value', title: this.$t('tables.events.headings.value'), dataClass: 'text-right-nowrap' },
        { name: 'threshold', title: this.$t('tables.events.headings.threshold'), dataClass: 'text-right-nowrap' },
        { name: 'fault_text', title: this.$t('tables.events.headings.fault_text') },
      ]
    },
    filterIssues () {
      return [{
        value: 0,
        label: 'All', // this.$t('dashboard.table.brief'),
      }, {
        value: 1,
        label: 'Issues', // this.$t('dashboard.table.detailed'),
      }]
    },
    filteredData () {
      let data = this.listData

      if (!this.term || this.term.length < 1) {
        return data
      }

      return data.filter(item => {
        return item.module_name.toLowerCase().indexOf(this.term.toLowerCase()) !== -1 ||
               item.fault_code.toLowerCase().indexOf(this.term.toLowerCase()) !== -1 ||
               item.fault_text.toLowerCase().indexOf(this.term.toLowerCase()) !== -1
      })
    },
  },

  methods: {
    formatGwTime (item) {
      // TODO: can probably make this a filter
      return DateTime.fromISO(item.gw_time).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
    },
    setData (newval) {
      this.loading = false
      this.listData = newval.items
      console.log('DET SET EVENT DATA: ', newval)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  mounted () {
    this.isLoading = true
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #BEBEBE;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.49, 0.11, 0.52, 0.88);;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
      -webkit-transform: rotate(0deg);
  }
  to {
      -webkit-transform: rotate(359deg);
  }
}
</style>
